<template>
  <div>
    <el-container>
      <el-header>
        <div style="margin: 20px 0">
          <el-button type="primary" @click="openCreateUserRoot(1)" size="small">创建账号</el-button>
        </div>
      </el-header>
      <el-main>
        <el-dialog title="设置权限" :visible.sync="dialogFormVisible1" width="100%" top="0vh" :fullscreen="true">
          <el-tree
            :data="data"
            show-checkbox
            default-expand-all
            node-key="_id"
            ref="tree"
            highlight-current
            :props="defaultProps">
          </el-tree>
          <div style="text-align: left;width: 100%;height: 120px;">
            <el-button type="primary" @click="getCheckedNodes">保存</el-button>
          </div>
        </el-dialog>
        <el-dialog
          title="提示"
          :visible.sync="centerDialogVisible"
          width="30%"
          center>
          <span>删除后将无法恢复，确定删除？</span>
          <span slot="footer" class="dialog-footer">
            <el-button @click="centerDialogVisible = false">取 消</el-button>
            <el-button type="primary" @click="qdCreateUserRoot">确 定</el-button>
        </span>
        </el-dialog>
        <el-dialog  title="创建/编辑" :visible.sync="dialogFormVisible" top="3vh">
          <div class="demo-input-suffix">
            账号类型：<el-checkbox v-model="checked" @change="isShowClass">商务账号</el-checkbox><el-checkbox v-model="userChecked" @change="isUserShowClass">客户账号</el-checkbox>
          </div>
          <div class="demo-input-suffix">
            角色名称：<br/>
            <el-input
              placeholder="请输入角色名称"
              v-model="rootName">
            </el-input>
          </div>
          <div class="demo-input-suffix">
            账号：
            <el-input
              placeholder="请输入账号"
              v-model="userName">
            </el-input>
          </div>
          <div class="demo-input-suffix">
            密码：
            <el-input
              type="password"
              placeholder="请输入密码，不支持特殊符号"
              v-model="pwd1">
            </el-input>
          </div>
          <div class="demo-input-suffix">
            确认密码：
            <el-input
              type="password"
              placeholder="请输入确认密码"
              v-model="pwd2">
            </el-input>
          </div>
          <div class="demo-input-suffix" v-show="classDiv">
            账号分类：<br/>
            <el-dropdown split-button type="primary" @command="commandEvent">
              <span v-html="dropdownTitle"></span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item,index) in dropdownList" :key="index" :command="item.label">{{item.label}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="demo-input-suffix" v-show="classUserDiv">
            客户选择：<br/>
            <el-dropdown split-button type="primary" @command="commandUserEvent">
              <span v-html="dropdownTitle"></span>
              <el-dropdown-menu slot="dropdown" class="project-dropdown">
                <el-dropdown-item v-for="(item,index) in dropdownUserList" :key="index" :command="item.identification">{{item.customerName}}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFormVisible = false">取 消</el-button>
            <el-button type="primary" @click="qdCreateUserRoot">确 定</el-button>
          </div>
        </el-dialog>
        <template>
          <el-table
            :data="tableData"
            border
            :height="divHeight"
            style="width: 100%">
            <el-table-column
              fixed
              prop="rootName"
              label="角色"
              width="180">
            </el-table-column>
            <el-table-column
              fixed
              prop="userName"
              label="账号"
              width="180">
            </el-table-column>
            <el-table-column
              fixed
              prop="class"
              label="账号分类"
              width="180">
            </el-table-column>
            <el-table-column
              fixed
              prop="userType"
              label="账号类型"
              width="180">
            </el-table-column>
            <el-table-column
              prop="state"
              label="状态操作"
              width="120">
              <template slot-scope="scope">
                <el-button @click="{{(scope.row.state?cz(1,scope.row._id):cz(2,scope.row._id))}}" type="text" size="small">{{(scope.row.state?'停用':'启用')}}</el-button>
              </template>
            </el-table-column>
            <el-table-column
              prop="updateTime"
              :formatter="formatTime"
              label="最后更新时间"
              width="180">
            </el-table-column>
            <el-table-column
              prop="createTime"
              :formatter="formatTime"
              label="创建时间"
              width="180">
            </el-table-column>
            <el-table-column
              fixed="right"
              label="操作"
              width="200">
              <template slot-scope="scope">
                <el-button @click="updateUserRoot(scope.$index, scope.row)" type="text" size="small">设置权限</el-button>
                <el-button @click="deleteUserRoot(scope.$index, scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-main>
      <el-footer>
        <el-pagination
          background
          @size-change="handleSizeChange0"
          @current-change="handleCurrentChange0"
          :current-page="currentPage0"
          :page-sizes="[100, 200, 300, 400]"
          :page-size="count0"
          layout="total, sizes, prev, pager, next, jumper"
          :total="allcount0">
        </el-pagination>
      </el-footer>
    </el-container>
  </div>
</template>
<script>
  import Dropdown from '@/components/Dropdown/index.vue'
  export default {
    name: 'userRoot',
    data(){
      return {
        checked:false,
        userChecked:false,
        classDiv:true,
        classUserDiv:false,
        dialogFormVisible:false,
        dialogFormVisible1:false,
        centerDialogVisible:false,
        tableData:[],
        allcount0:0,//总页数 对应 total
        count0:100,//一页显示多少量 对应 page-size
        currentPage0:1,//当前页数
        rootName:"",
        userName:"",
        pwd1:"",
        pwd2:"",
        state:true,
        isType:1,
        isId:"",
        divHeight:500,
        data: [],
        dropdownList:[],
        dropdownUserList:[],
        dropdownTitle:"请选择",
        userType:"渠道账号",
        defaultProps: {
          children: 'children',
          label: 'label',
          sort:'sort',
          level:'level',
          url:'url'
        }
      }
    },
    components: {
      Dropdown
    },
    methods:{
      addClass:async function(){
        await this.$axios.post('/data/addClass',{
          uid:""
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownList = response.data[0];
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      addUser:async function(){
        await this.$axios.post('/root/addUser',{
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.dropdownUserList = response.data;
          }else if(response.data.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      formatTime:function(row, column) {
        var date = new Date(row[column.property]);
        var format = "yyyy-MM-dd hh:mm:ss";
        var o = {
          "M+" : date.getMonth()+1, //month
          "d+" : date.getDate(),    //day
          "h+" : date.getHours(),   //hour
          "m+" : date.getMinutes(), //minute
          "s+" : date.getSeconds(), //second
          "q+" : Math.floor((date.getMonth()+3)/3),  //quarter
          "S" : date.getMilliseconds() //millisecond
        };
        if(/(y+)/.test(format)) format=format.replace(RegExp.$1,
          (date.getFullYear()+"").substr(4 - RegExp.$1.length));
        for(var k in o)if(new RegExp("("+ k +")").test(format))
          format = format.replace(RegExp.$1,
            RegExp.$1.length==1 ? o[k] :
              ("00"+ o[k]).substr((""+ o[k]).length));
        return format;
      },
      openCreateUserRoot:function (val) {
        this.isType = val;
        this.dialogFormVisible = true;
      },
      openDeleteUserRoot:function (val) {
        this.isType = val;
        this.centerDialogVisible = true;
      },
      qdCreateUserRoot:function () {
        this.isAjax();
      },
      isAjax:async function(){
        if(this.isType == 1){
          if(this.rootName == ""){
            this.$message({
              message: "角色名称不能为空",
              type: 'warning'
            });
            return false;
          }else if(this.userName == ""){
            this.$message({
              message: "账号不能为空",
              type: 'warning'
            });
            return false;
          }else if(this.userName.length<6 && this.userName.length>18){
            this.$message({
              message: "账号长度要大于6小于18",
              type: 'warning'
            });
            return false;
          }else if(this.pwd1 == ""){
            this.$message({
              message: "账号密码不能为空",
              type: 'warning'
            });
            return false;
          }else if(this.pwd1 != this.pwd2){
            this.$message({
              message: "账号密码与确定密码不一致",
              type: 'warning'
            });
            return false;
          }else if(this.pwd1.length<6 && this.pwd1.length>18){
            this.$message({
              message: "账号密码长度要大于6小于18",
              type: 'warning'
            });
            return false;
          }else if(this.checked == false && (this.dropdownTitle == "" || this.dropdownTitle == "请选择")){
            this.$message({
              message: "请选择账号分类",
              type: 'warning'
            });
            return false;
          }
        }
        if(this.checked){
          this.dropdownTitle = "";
        }
        await this.$axios.post('/root/userRootMessage',{
          "t":this.isType,
          "rootName":this.rootName,
          "userName":this.userName,
          "passWord":this.pwd1,
          "state":this.state,
          "classification":this.dropdownTitle,
          "userType":this.userType,
          "id":this.isId
        }).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            if(this.isType == 5){
              var aaa = response.data;
              this.$refs.tree.setCheckedKeys(aaa);
            }else{
              this.$message({
                message: response.message,
                type: 'success'
              });
              this.addUserRoot();
              this.dialogFormVisible = false;
              this.centerDialogVisible = false;
              this.pwd1 = "";
              this.pwd2 = "";
              this.rootName = "";
              this.userName = "";
              this.dropdownTitle = "请选择";
              this.state = true;
            }
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }

        }).catch(function (error) {
          this.$message.error(error);
        });
      },
      addUserRoot:async function(){
        await this.$axios.post('/root/addUserRoot',{}).then((response,err) => {
          response = response.data;
          if(response.code == "Login" || response.code == "WhiteList"){
            this.$message.error(response.message);
          }else if(response.code == "Success"){
            this.tableData = response.data[0];
            this.allcount0 = response.data[1];
            this.data = response.data[2];
          }else if(response.code == "Fail"){
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }else{
            this.$message({
              message: response.message,
              type: 'warning'
            });
          }
        }).catch(function (error) {
          this.$message.error(error);
        });
        this.divHeight = window.innerHeight-158;
      },
      handleSizeChange0(val) {
        this.count0 = val;
        this.addUserRoot();
      },
      handleCurrentChange0(val) {
        this.currentPage0 = val;
        this.addUserRoot();
      },
      updateUserRoot(index, row) {
        this.isId = row._id;
        this.rootName = row.rootName;
        this.userName = row.userName;
        this.state = row.state;
        this.isType = 5;
        this.dialogFormVisible1 = true;
        this.isAjax()
      },
      commandEvent(command) {
        this.dropdownTitle = command
      },
      commandUserEvent(command) {
        this.dropdownTitle = command
      },
      deleteUserRoot(index, row){
        this.isId = row._id;
        this.rootName = row.rootName;
        this.userName = row.userName;
        this.state = row.state;
        this.openDeleteUserRoot(4);
      },
      cz(val,id){
        var isState = true;
        this.isId = id;
        if(val == 1){
          isState = false;
        }else if(val == 2){
          isState = true;
        }
        this.state = isState;
        this.isType = 2;
        this.isAjax();
      },
      getCheckedNodes:async function() {
        var _list = this.$refs.tree.getCheckedNodes(false,true);
        if(_list.length>0){
          await this.$axios.post('/root/addUserMenu',{
            "id":this.isId,
            "list":_list
          }).then((response,err) => {
            response = response.data;
            if(response.code == "Login" || response.code == "WhiteList"){
              this.$message.error(response.message);
            }else if(response.code == "Success"){
              this.$message({
                message: response.message,
                type: 'success'
              });
              this.dialogFormVisible1 = false;
              this.addUserRoot();
            }else if(response.code == "Fail"){
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }else{
              this.$message({
                message: response.message,
                type: 'warning'
              });
            }
          }).catch(function (error) {
            this.$message.error(error);
          });
        }else{
          this.$message({
            message: "请勾选功能菜单",
            type: 'warning'
          });
        }
      },
      isShowClass(){
        this.userChecked = false;
        this.dropdownTitle = "请选择";
        if(this.checked){
          this.userType = "商务账号";
          this.classDiv = false;
          this.classUserDiv = false;
        }else{
          if(this.userChecked){
            this.classUserDiv = true;
          }else{
            this.userType = "渠道账号";
            this.classDiv = true;
          }
        }
      },
      isUserShowClass(){
        this.checked = false;
        this.dropdownTitle = "请选择";
        if(this.userChecked){
          this.userType = "客户账号";
          this.classDiv = false;
          this.classUserDiv = true;
        }else{
          this.userType = "渠道账号";
          this.classDiv = true;
          this.classUserDiv = false;
        }
      }
    },
    mounted(){
      this.addClass();
      this.addUser();
      this.addUserRoot();
    }
  }
</script>
<style scoped>
  body{
    padding: 0;
    margin: 0;
  }
  .demo-input-suffix{
    margin-bottom: 10px !important;
  }
  .project-dropdown{
    height:300px !important;
    overflow: auto;
  }
  .project-dropdown::-webkit-scrollbar
  {
    width: 5px;
    height: 5px;
    background-color: #F5F5F5;
  }
  .project-dropdown::-webkit-scrollbar-track
  {
    -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
    border-radius: 10px;
    background-color: #F5F5F5;
  }
</style>



// WEBPACK FOOTER //
// src/views/main/userRoot.vue